var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"layout"},[(_vm.hasToShowOldMenu)?_c('NavbarBack',{attrs:{"title":_vm.titlePage,"back":_vm.backPage,"additionalLinksMobile":_vm.additionalLinksMobile},on:{"backButtonClicked":_vm.backButtonClicked}}):_vm._e(),(_vm.notification.show)?_c('Notification'):_vm._e(),_vm._t("default"),_c('ModalChangesUnsaved')],2)
}
var staticRenderFns = []

export { render, staticRenderFns }